export const TOKEN_STORAGE = 'saywhattToken';
export const CHAT_ID_STORAGE = 'saywhattChatId';
export const OPEN_CHAT_STORAGE = 'saywhattIsOpenChat';
export const SESSION_FINISH_TIME_STORAGE = 'saywhattSessionFinishTime';
export const IS_TOOLTIP_CLOSED_STORAGE = 'saywhattIsTooltipClosed';
export const TOOLTIP_SHOWN_PAGES = 'saywhattTooltipShownPages';
